import { WarningAmber } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

export const WarningIcon = ({tooltipText, size}) => {
  return (
      <Tooltip title={tooltipText}>
        <WarningAmber color="warning" sx={{ fontSize: size || 22 }} />
      </Tooltip>
  );
};
